import $ from 'jquery';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { generateClassNameString } from 'helper/css';

import withSaveScrollPosition from 'components/hoc/withSaveScrollPosition';
import { WithSaveScrollPositionPropsType } from 'components/hoc/withSaveScrollPosition';
import { SCROLL_ELEMENT_ID } from 'types/ScrollElementId';

export type FilterItemType = {
	link: string;
	id: string;
	label: string;
};

export type OriginFilterPropsType = {
	filters: FilterItemType[];
	selected: string;
	isLoading?: boolean;
	isUiControlled?: boolean;
	modifier?: string;
	classNameItem?: string;
	classNameLink?: string;
	shouldUseReplace?: boolean;
	onChange?: (selected: string) => void;
};

export type FilterPropsType = OriginFilterPropsType & WithSaveScrollPositionPropsType;

export type FilterStateType = {
	selected: string;
};

export class Filter extends React.Component<FilterPropsType, FilterStateType> {
	public static displayName = 'Filter';
	public static defaultProps = {
		filters: [],
		selected: '',
		isUiControlled: false,
		shouldUseReplace: false,
	};

	public thisDomNode: HTMLDivElement | null = undefined as any;

	constructor(props: FilterPropsType) {
		super(props);

		this.state = {
			selected: props.selected.toLowerCase() || '',
		};
	}

	public componentWillReceiveProps(nextProps) {
		if (nextProps.selected !== this.state.selected) {
			this.setState({
				selected: nextProps.selected,
			});
		}
	}

	public componentDidMount() {
		const { isLoading = false } = this.props;
		if (isLoading || !this.thisDomNode) {
			return;
		}
		$(this.thisDomNode).scrollLeft(this.props.scrollPosition || 0);
	}

	public setSelectedItem(selected: string) {
		if (!this.props.isUiControlled) {
			this.props.doSaveScrollPosition(this.thisDomNode ? $(this.thisDomNode)!.scrollLeft()! : 0);
			this.setState(
				{
					selected,
				},
				() => {
					if (this.props.onChange) {
						this.props.onChange(selected);
					}
				}
			);
		}
	}

	public render() {
		const { selected } = this.state;
		const { filters, modifier, classNameItem, classNameLink, isLoading = false, shouldUseReplace } = this.props;

		return (
			<div
				ref={(input) => (this.thisDomNode = input)}
				className={`${generateClassNameString('m-filter', modifier)}${
					isLoading ? ' state-m-filter--loading' : ''
				}`}
			>
				<ul className="m-filter__list">
					{filters.map((filter: FilterItemType, index: number) => {
						const { link, id, label } = filter;
						const state = id.toLowerCase() === selected ? ' state-m-filter__link--selected' : '';

						if (isLoading) {
							return (
								<li
									key={`$.filter-item-${link}-${index}`}
									className={`m-filter__item ${classNameItem || ''}`}
								>
									<div className={`m-filter__link${state} ${classNameLink || ''}`}>
										<span className="m-filter__label">{label}</span>
									</div>
								</li>
							);
						}

						return (
							<li
								key={`$.filter-item-${link}-${index}`}
								className={`m-filter__item ${classNameItem || ''}`}
								onClick={() => this.setSelectedItem(id)}
							>
								<RouterLink
									to={link}
									className={`m-filter__link${state} ${classNameLink || ''}`}
									replace={shouldUseReplace}
								>
									<span className="m-filter__label">{label}</span>
								</RouterLink>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}

export default withSaveScrollPosition(Filter, SCROLL_ELEMENT_ID.FILTER as any);
